import React, {Component} from 'react';
import {View, Image,TouchableOpacity} from 'react-native';
import {moderateScale} from "../../tools/Scaling"
import HMTextView from "../HMTextView";
import  Colors from "../../tools/Colors";
import LottieView from "react-native-web-lottie";
import i18n from "../../I18n/i18n";

export default class EmptyView extends Component {
    render() {
        const {text,empty, backgroundColor, height} = this.props;
        return !empty
            ? null
            :
            <View style={{
                width: "100%",
              //  backgroundColor: backgroundColor ? backgroundColor : "white",
                height: height ? height : "100%",
                alignItems: "center",
                justifyContent: "center"

            }}>
                {/*<Image source={require("../assets/img/pizza.png")}*/}
                       {/*style={{width: moderateScale(180), height: moderateScale(180)}}/>*/}


                <LottieView style={{width: moderateScale(150), height: moderateScale(150)}}
                            source={require('../../assets/animations/empty-list')}

                            autoPlay loop/>



                <HMTextView type={"bold"} style={{
                    fontSize: moderateScale(16),
                    marginTop: moderateScale(6),
                    color: Colors.gray,
                    // marginTop: moderateScale(10)
                }}
                    // text={item.name}
                     text={text?text:i18n.t('constant.not_found')}
                />
            </View>

    }
}
